import * as React from 'react'
import { useSelector, useDispatch } from 'react-redux';
import Stack from '@mui/material/Stack'
import Button from '@mui/material/Button'
import MuiSnackbar from '@mui/material/Snackbar'
import MuiAlert, { AlertProps } from '@mui/material/Alert'
import {
  selectSnackbar,
  resetSnackbar,
} from './snackbarSlice'

const Alert = React.forwardRef(function Alert(
  props,
  ref,
) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />
});

const Snackbar = () => {
  const dispatch = useDispatch()
  const { open, message, severity } = useSelector(selectSnackbar)

  const onClose = () => {
    //console.log('[Snackbar] onClose')
    dispatch(resetSnackbar())
  }

  //console.log('[Snackbar]', open, severity, message)

  return (
    <MuiSnackbar open={open} autoHideDuration={5000} onClose={onClose}>
      <Alert onClose={onClose} severity={severity} sx={{ width: '100%' }}>
        { message }
      </Alert>
    </MuiSnackbar>
  )
}

export default Snackbar
